module.exports = __webpack_public_path__ + "img/icon-exit-login.9d5dab55.svg";